import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasShadow, setHasShadow] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      setHasShadow(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header d-flex align-items-center sticky-top ${hasShadow ? 'shadow-sm' : ''}`}>
      <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
        {/* Logo */}
        <Link to="/" className="logo d-flex align-items-center text-decoration-none">
          <h1 className="sitename m-0">
            <span className="first-word">Railing&nbsp;</span>
            <span className="second-word">World</span>
          </h1>
        </Link>

        {/* Nav & Hamburger */}
        <div className="d-flex align-items-center">
          <nav className="navmenu d-none d-xl-block me-3">
            <ul className="d-flex list-unstyled mb-0 gap-4">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/product">Product</Link></li>
              <li><Link to="/category">Category</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>
          <button
            className="mobile-nav-toggle d-xl-none btn btn-link"
            onClick={toggleMenu}
          >
            <i className="bi bi-list fs-2"></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-drawer ${isMenuOpen ? 'open' : ''}`}>
          <button className="close-btn btn btn-link" onClick={closeMenu}>
            <i className="bi bi-x-lg fs-2"></i>
          </button>
          <ul className="mobile-nav-list list-unstyled mt-4">
            <li><Link to="/" onClick={closeMenu}>Home</Link></li>
            <li><Link to="/about" onClick={closeMenu}>About</Link></li>
            <li><Link to="/product" onClick={closeMenu}>Product</Link></li>
            <li><Link to="/category" onClick={closeMenu}>Category</Link></li>
            <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
          </ul>
        </div>

        {isMenuOpen && <div className="mobile-overlay" onClick={closeMenu}></div>}
      </div>
    </header>
  );
}